
// src/connects/user-profile-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import uploadFiles from '../helpers/file-upload'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import componentId from '../helpers/component-id'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import { validate } from '../helpers/form-validator'
import { emitAlertMessage } from '../actions/alert-message'
import find from 'lodash/find'
import moment from 'moment'

export const mapStateToProps = (state, ownProps)=> {
  const uploadFile = state.uploadFile[ownProps.componentId]

  return {
    user: state.user.current,
    isProfileUpdating: state.user.isProfileUpdating,
    isProfileUpdateFailed: state.user.isProfileUpdateFailed,
    _uploadFile: state.uploadFile[ownProps.componentId],
    userProfileTemplate : state.templates && state.templates.userProfileTemplate && state.templates.userProfileTemplate 
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  var uploadFile
  if (stateProps._uploadFile) {
    uploadFile = find(stateProps._uploadFile, (value, key)=> value)
  }

  return {
    isUploading: uploadFile && uploadFile.isUploading,
    uploadedFile: uploadFile && uploadFile.item,
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    validateAndSubmit: (props, crop, event = undefined) => {
      if (event && event.preventDefault)
        event.preventDefault();

      validate(props.ui, {
        name: { rule: 'isRequired' },
      }, (errors, nextUI) => {
        props.updateUI(nextUI)
        if (!errors)
          props.ui.handlers && props.ui.handlers.getValue((desc) => {
            dispatch(actions.updateUserProfile(
              props.ui.name,
              props.uploadedFile && props.uploadedFile.file_id,
              props.ui.employmentNumber,
              props.ui.department_id,
              props.ui.birthday.format('YYYY-MM-DD'),
              props.ui.isUpdateBirthday,
              crop,
              desc
            ))
          })
      })
      return false
    },

    uploadFile: (props, file)=> !props.isUploading && uploadFiles(
      file, dispatch, props.user.user_id, 'user',
      ownProps.componentId, true
    ),

    importUserProfileTemplate: () => {
      dispatch(actions.importUserProfileTemplate())
    },

    clearUserProfileTemplate: () => {
      dispatch(actions.clearUserProfileTemplate())
    },

    willUpdate: (props, nextProps)=> {
      // changing isFetching true => false
      if (props.isProfileUpdating && !nextProps.isProfileUpdating) {
        if (!nextProps.isProfileUpdateFailed) { // successfully updated
          dispatch(actions.clearUploadFilesAndVideos(nextProps.componentId))
          nextProps.updateUI({
            name: nextProps.user.name,
            nameError: undefined,
          })
          dispatch(emitAlertMessage("label:プロフィールを更新しました", "success"))
        }
      }
    },

    willUnmount: (props)=> {
      dispatch(actions.clearUploadFilesAndVideos(props.componentId))
    }
  }
}

export default combineHOC(
  componentId,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: {
    name: (props)=> props.user && props.user.name,
    nameError: undefined,
    handlers: undefined,
    employmentNumber: (props)=> props.user && props.user.employment_number,
    department_id: (props)=> props.user && props.user.department ? props.user.department.id : 0,
    birthday: (props)=> props.user && props.user.birthday ? moment(props.user.birthday) : moment(new Date()),
    isUpdateBirthday: (props)=> props.user && props.user.birthday ? true : false,
  }}),
  lifecycle,
  translate(),
  trackPage('user_profile'),
)



// WEBPACK FOOTER //
// ./src/connects/user-profile-panel.js